import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'banking',
  children: {
    accounts: {
      path: 'accounts',
      size: 'full',
      children: {
        accountId: {
          path: ':id',
          size: 'full',
          children: {
            transactions: {
              path: 'transactions',
              size: 'full',
              children: {
                transactionId: {
                  path: ':transaction_id',
                  size: 'full',
                },
              },
            },
            cards: {
              path: 'cards',
              size: 'full',
              children: {
                cardId: {
                  path: ':card_id',
                  size: 'full',
                },
              },
            },
            card_payments: {
              path: 'card_payments',
              size: 'full',
            },
            reconciliations: {
              path: 'reconciliations',
              size: 'full',
              children: {
                new: {
                  path: 'new',
                  size: 'full',
                },
              },
            },
          },
        },
      },
    },
    onboardings: {
      path: 'onboardings',
      size: 'full',
    },
    payments: {
      path: 'payments',
      size: 'full',
      children: {
        paymentId: {
          path: 'bulk-payments/:id',
          size: 'full',
        },
        transfers: {
          path: 'transfers',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
